import React, { useState } from 'react';
import styled from 'styled-components';
const Container = styled.div `
  width: 100%;
  border: 1px solid #eef0f3;
  border-radius: 4px;
  padding: 16px 24px;
`;
const Header = styled.div `
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${({ isOpen }) => (isOpen ? '8.5px' : '0px')};
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
`;
const Chevron = styled.img `
  transition: transform 0.4s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
`;
export const Accordion = ({ children, title, defaultOpen = false, }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    return (React.createElement(Container, null,
        React.createElement(Header, { isOpen: isOpen, onClick: () => setIsOpen(!isOpen) },
            React.createElement("div", null, title),
            React.createElement(Chevron, { isOpen: isOpen, src: "/images/icon-chevron-down.svg", alt: "chevron icon" })),
        isOpen && React.createElement(React.Fragment, null, children)));
};
